export const COLORS = {
    POSITIVE_IMPORTANT: 'RED',
    FALSE_POSITIVE_IMPORTANT: 'BLUE',
    FALSE_POSITIVE: 'GREEN',
    POSITIVE_NOT_IMPORTANT: '#FFBF00',
    ACTION_NOT_REQUIRED: '#013603',
    ACTION_REQUIRED: '#5E0600',
    NOT_REVIEWED: 'WHITE',
    QUARANTINE: '#AD62B8',
  };
  